'use client';

import { Results } from 'payments-lib-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getDetailedPaymentsErrorText } from '@/helpers/payment';
import { showTooltip } from '@/helpers/tooltip';
import { useCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';

interface ISubmitResult extends Results.SubmitResult {
  type: string;
}

export const useErrorsNotifications = (submitData?: ISubmitResult) => {
  const { t } = useTranslation('deposits');

  const user = useCommonStore.use.user();

  useEffect(() => {
    if (submitData?.type === 'params_error') {
      getDetailedPaymentsErrorText(submitData, t, user?.currency);
    }

    if (submitData?.type === 'request_error') {
      showTooltip({
        type: TooltipTypes.ERROR,
        body: submitData.message,
        removeTimeout: 10000,
      });
    }
  }, [submitData, t, user?.currency]);
};
